interface ArrowBackProps {
  className?: string;
}

export default function ArrowBack({ className }: ArrowBackProps) {
  return (
    <svg
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_6466_748"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_6466_748)">
        <path
          d="M7.021 10.8334L11.6877 15.5L10.5002 16.6667L3.8335 10L10.5002 3.33337L11.6877 4.50004L7.021 9.16671H17.1668V10.8334H7.021Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
